import { DateRangeField, DecoratedFormUnit, SwitchField } from '@mi-front/ui';
import { useField, useFormikContext } from 'formik';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { useTimezone } from '../../../../../../core/hooks';

export function NoMatchesReportForm() {
  const { $t } = useIntl();
  const tz = useTimezone();

  const { isSubmitting } = useFormikContext();
  const [useSameRangeField] = useField('useSameRange');

  return (
    <div className="row">
      <div className="col-md-4">
        <DecoratedFormUnit
          label={$t({
            id: 'audit.props.creationRange',
            defaultMessage: 'Intervalo de carga del material',
          })}
        >
          <DateRangeField
            name={['audioFrom', 'audioTo']}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </DecoratedFormUnit>
      </div>
      <div className="col-md-6">
        <DecoratedFormUnit
          label={$t({
            id: 'audit.reportsScreen.noMatches.matchRange',
            defaultMessage: 'Intervalo de matches',
          })}
        >
          <DateRangeField
            disabled={isSubmitting || useSameRangeField.value}
            name={['matchFrom', 'matchTo']}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
          <div className="mt-2">
            <SwitchField size="sm" name="useSameRange" disabled={isSubmitting} />
            &nbsp;&nbsp;
            <label>
              {$t({
                id: 'audit.reportsScreen.noMatches.useSameRangeLabel',
                defaultMessage: 'Usar mismo rango de carga del archivo',
              })}
            </label>
          </div>
        </DecoratedFormUnit>
      </div>
    </div>
  );
}
